import { featuredArticles, articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              精选文章
            </h2>
            <p className="text-sm text-foreground-600">最受欢迎的秘密教学方法精讲</p>
          </div>
          <Link
            to="/category/hexin-fangfa"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>

        <div className="mt-12">
          <div className="flex items-end justify-between mb-6">
            <h3 className="text-lg font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              最新文章
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {articles.filter(a => !a.featured).slice(0, 8).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>

        <div className="text-center mt-10 sm:hidden">
          <Link
            to="/category/hexin-fangfa"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}